import AddIcon from '@mui/icons-material/Add';
import ArticleIcon from '@mui/icons-material/Article';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import BorderInnerIcon from '@mui/icons-material/BorderInner';
import DataObjectIcon from '@mui/icons-material/DataObject';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import RemoveIcon from '@mui/icons-material/Remove';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import { Badge,Card,Divider,IconButton,List,ListItem,ListItemIcon,ListItemText,Stack,Tooltip,Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ListaArquivos({ arquivos, setArquivos, open, setOpen, disabled = false }: { arquivos: File[], setArquivos: Function, open: boolean, setOpen: Function, disabled?: boolean }) {
  const { t } = useTranslation('translation');
  const getFileType = (value: string) => {
    const fileName = value?.substring(value.lastIndexOf('.') + 1);
    switch (fileName) {
      case 'pdf':
        return (<PictureAsPdfIcon />);
      case 'doc': case 'docx': case 'txt':
        return (<ArticleIcon />);
      case 'xls': case 'xlsx':
        return (<BorderInnerIcon />);
      case 'json':
        return (<DataObjectIcon />);
      case 'audio':
        return (<AudioFileIcon />);
      case 'video':
        return (<VideoFileIcon />);
    }
  };

  function truncateFileName(name: string, maxLength = 20) {
    if (name.length <= maxLength) return name;
    const extIndex = name.lastIndexOf('.');
    const ext = extIndex !== -1 ? name.substring(extIndex) : '';
    const base = name.substring(0, maxLength - ext.length - 3);
    return `${base}...${ext}`;
  };

  function removeItem(item: File) {
    setArquivos(Array.from(arquivos).filter((elem) => elem !== item));
  }

  return (
    <Card>
      <Stack direction='row' alignItems='center' justifyContent='space-between' width='100%' height={60} paddingLeft={2} paddingRight={2}>
        <Stack direction='row' alignItems='center' justifyContent='flex-start' spacing={2}>
          <Badge color='primary' badgeContent={arquivos?.length} />
          <Typography color='textDisabled' fontSize={12} fontWeight={600}>{t('notifications.ticket.filesAdded')}</Typography>
        </Stack>
        {!open ?
          <IconButton disabled={disabled} onClick={() => setOpen()}>
            <AddIcon />
          </IconButton>
          : <IconButton disabled={disabled} onClick={() => setOpen()}>
            <RemoveIcon />
          </IconButton>}
      </Stack>
      {open && <>
        <Divider variant='middle' orientation='horizontal' flexItem />
        <List>
          {arquivos.map((arquivo, index) => (
            <Tooltip key={`${arquivo.name}|${index}`} title={arquivo.name}>
              <ListItem>
                <ListItemIcon>{getFileType(arquivo.name)}</ListItemIcon>
                <ListItemText primary={truncateFileName(arquivo.name)} />
                <IconButton color="error" disabled={disabled} onClick={() => removeItem(arquivo)}>
                  <RemoveCircleIcon />
                </IconButton>
              </ListItem>
            </Tooltip>
          ))}
        </List>
      </>}
    </Card>
  );
}
